import React from "react";
import { BaseTextMergeElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { TextMergeEditContext } from "../../rule-engine-core/TextMerge/TextMergeEditContext";

export abstract class BaseTextMergeEditor<T extends BaseTextMergeElement> {
    editorData?: T;

    getEditorData(): BaseTextMergeElement {
        return this.editorData!;
    }

    abstract renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode;

    abstract renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode;

    abstract getIcon(): JSX.Element;
}
